<template>
    <v-alert
        :value="display"
        type="success"
        dismissible
    >
        {{content}}
    </v-alert>
</template>

<script>
    export default {
        components: {
            
        },
        props: [
            // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
            //eslint-disable-next-line
            "content", 
            // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
            //eslint-disable-next-line
            "display"
        ],
        methods:{
        }
    }
</script>
